import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import { createAppRouter } from './router'

import { config } from './config'
import keycloak from './keycloak'
import { keycloakJoignable, retenirPersonne } from './horsLigne'
import { useAuthStore } from './stores/auth'
import PrimeVue from 'primevue/config'
import { PRIMEVUE_FR } from '@/utils/primevueFr'
import ConfirmationService from 'primevue/confirmationservice'
import { MamarottePreset } from './assets/styles/preset'
// Comportement commun des dialogues : avant le premier dialogue monté
import './primevueDialogue'

import './assets/styles/fonts.css'
import './assets/styles/tokens.css'
import './assets/styles/base.scss'

// Lien d'invitation reçu par mail : seul keycloak-js peut produire le PKCE exigé par Keycloak.
// Il redirige vers l'inscription ; au retour, l'initialisation normale ci-dessous échange le code.
const REGISTRATION_PATH = '/inscription'
// Gardée par le service worker : hors ligne, sans rien de gardé à consulter
const PAGE_HORS_CONNEXION = '/hors-connexion.html'

/** Sans le routeur : sa première navigation passe par le garde d'authentification, la personne doit être connue. */
function creerApp() {
  const app = createApp(App)

  app.use(PrimeVue, {
    locale: PRIMEVUE_FR,
    theme: {
      preset: MamarottePreset,
      options: {
        darkModeSelector: '[data-theme="dark"]',
        cssLayer: false,
      },
    },
  })
  app.use(ConfirmationService)
  app.use(createPinia())
  return app
}

async function demarrerEnLigne() {
  const authenticated = await keycloak.init({
    onLoad: 'login-required',
    checkLoginIframe: false,
  })
  if (!authenticated || !keycloak.subject) return

  await retenirPersonne(keycloak.subject)
  const app = creerApp()
  const auth = useAuthStore()
  auth.sync()
  app.use(createAppRouter())
  // Avant le montage : les vues se reconnaissent par l'id de la personne (« vous », mes rôles, mes droits)
  await auth.chargerMoi()

  // Rafraîchit le token 30s avant expiration. Pas de déconnexion sur échec : une coupure réseau ferait perdre
  // la saisie en cours, et une session morte renvoie déjà vers la connexion (keycloak-js, login-required).
  setInterval(() => {
    keycloak.updateToken(30).catch(() => {})
  }, 60_000)

  app.mount('#app')
}

/** Sans Keycloak, ni jeton : chaque lecture échoue sur le réseau et le service worker sert sa copie. */
async function demarrerHorsLigne() {
  const app = creerApp()
  if (!(await useAuthStore().reprendreHorsLigne())) {
    window.location.replace(PAGE_HORS_CONNEXION)
    return
  }
  app.use(createAppRouter())
  app.mount('#app')
}

if (window.location.pathname === REGISTRATION_PATH) {
  keycloak.init({ checkLoginIframe: false }).then(() => keycloak.register({ redirectUri: window.location.origin + '/' }))
} else if (await keycloakJoignable(`${config.keycloakUrl}/realms/${config.keycloakRealm}`)) {
  await demarrerEnLigne()
} else {
  await demarrerHorsLigne()
}
